import { useEffect } from 'react';
import './ImagePreview.css';
import ImageWithLoader from '../ImageWithLoader/ImageWithLoader';

export default function ImagePreview({ imageUrl, alt, onClose }) {
  useEffect(() => {
    if (!imageUrl) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose?.();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [imageUrl, onClose]);

  useEffect(() => {
    if (!imageUrl) return undefined;

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [imageUrl]);

  if (!imageUrl) return null;

  return (
    <div className="ImagePreview" role="dialog" aria-modal="true">
      <div
        className="ImagePreview__backdrop"
        onClick={onClose}
        role="presentation"
      />
      <div className="ImagePreview__content" role="document">
        <button
          className="ImagePreview__close"
          type="button"
          onClick={onClose}
          aria-label="Close preview"
        >
          <svg
            className="ImagePreview__closeIcon"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18 17.94 6M18 18 6.06 6"
            />
          </svg>
        </button>
        <ImageWithLoader
          wrapperClassName="ImagePreview__imageWrap"
          className="ImagePreview__image"
          src={imageUrl}
          alt={alt || 'Preview'}
        />
      </div>
    </div>
  );
}
